import React, { forwardRef } from 'react';
const ToolbarSpacer = forwardRef((props, ref) => {
    return React.createElement("span", Object.assign({ ref: ref, style: { flexGrow: 1 }, className: "spacer" }, props));
});
ToolbarSpacer.displayName = 'ToolbarSpacer';
export { ToolbarSpacer };
